import { Create, Edit } from 'react-admin';
import { TagForm, TagList } from '../tag';
import { EditToolbar } from '@components/EditToolbar';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

export const TicketTagList = TagList;

export const TicketTagCreate = () => (
  <Create>
    <TagForm domain="ticket" />
  </Create>
);

export const TicketTagEdit = () => (
  <Edit mutationMode="pessimistic">
    <TagForm domain="ticket" toolbar={<EditToolbar />} />
  </Edit>
);

export const TicketTagIcon = LocalOfferIcon;
